/**
 * 캐시내역 시트 (일지 카드 > 캐시내역)
 *
 * 구 Diary/Main.js 의 전역 cash_view() 이관.
 * 그때는 ajax 응답을 문자열로 만들어 BS 에 즉석 target({ init(){ html() } }) 으로 넘겼다 —
 * destroy() 가 없어 다음 시트가 열릴 때 내용이 남았다(캐시내역 → MY 메모 잔상).
 *
 * 본문은 오더 상세 시트($j.F.Mobile.OrderSheet)의 '이 오더의 충전금' 카드 한 장이다 — 같은 static 함수로 그린다.
 * .ods 로 감싸므로 시트 헤더 고정 · 크림 바탕(features/_order-sheet.scss)도 같이 탄다.
 *
 * [호출]
 *   $j.F.Diary.CashLog.open(ordernum)      // window.cash_view 브리지가 이걸 부른다
 */
import OrderSheet from '../Mobile/OrderSheet';

export default class CashLog {
    /** 시트 열기 — 데이터 로드는 init() 이 맡는다(시트가 먼저 뜨고 카드가 채워진다). */
    open(ordernum) {
        $j.Ui.BS.open({
            target: '$j.F.Diary.CashLog',
            fixedHeight: true,   // content-area 가 확정 높이를 얻어야 스크롤된다
            data: { ordernum },
        });
        $j.Ui.BS.setTitle('캐시내역');
    }

    init() {
        this.$el = $(`#${this.id}`);
        this.$el.html(`<div class="ods">${OrderSheet.logsHtml('cash')}</div>`);
        OrderSheet.fillLogs(this.$el, 'cash', this.data.ordernum);
    }

    destroy() {
        this.$el?.off();
    }
}
